module.exports = __webpack_public_path__ + "img/construction.0c07a62c.png";